import en from './en';
import fi from './fi';
import de from './de';
import sv from './sv';

const locales: { [key: string]: LocaleType } = {
  en,
  fi,
  de,
  sv,
};

export default locales;
